<template>
  <div :class="$style['test-again']">
    <el-dialog :visible="dialogVisible" title="" @close="cancel">
      <pt-sub-title title="复测">
      </pt-sub-title>

      <pt-form-item label="复测类型：" :labelWidth="labelWidth" :required="true">
        <wt-selector :options="options" name="reason" data-vv-as="原因" v-validate="'required'" v-model="form.reason" :clearable="true" :allow-create="true" :filterable="true" @mousedown.stop.native @click.stop.native :props="reasonProps" :noDataText="'暂无选项，请您直接录入内容'"></wt-selector>
      </pt-form-item>
      <!-- <pt-form-item label="备注：" :labelWidth="labelWidth">
          <el-input placeholder="请填写备注" v-model="form.batchNumber" type="textarea"></el-input>
        </pt-form-item> -->
      <div class="button-div">
        <el-button type="primary" @click="submit">确认</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  validate
} from 'utils/validate'
export default {
  name: 'delay-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      labelWidth: '100px',
      form: {

      },
      options: [],
      reasonProps: {
        label: 'name',
        value: 'id'
      }
    }
  },
  watch: {

  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    submit () {
      this.formValidata().then(() => {
        this.$emit('submit', this.form)
      })
    },
    cancel () {
      this.$emit('close')
    }

  }
}
</script>
<style module lang="less">
@import "~less/var";
.test-again{
  :global{
		.wt-selector{
			max-width: 100%;
		}
		.el-input__inner{
			max-width: 100%;
		}
   .button-div{
    margin-top: 40px;
   }
	}
}
</style>
